module.exports = __webpack_public_path__ + "static/3-4c115313b8e13da726bad599410544ff.jpg";